
import GeoJSON from 'ol/format/GeoJSON';
import WKT from 'ol/format/WKT';
import { buffer as extentBuffer, extend as extentExtend } from 'ol/extent';
import {fromExtent} from 'ol/geom/Polygon';

import MapCommand from './MapCommand';

export default class MapCommandZoomFeature extends MapCommand {

    constructor(options) {
        super(options);
        this._name = 'ZOOM_FEATURE';
    }

    execute(olMap, params) {
        let geometry = this.getGeometry(params);
        if(geometry) {
            let extent = extentBuffer(geometry.getExtent(), 100);
            let options = params.options || {duration: 500};
            options.size = olMap.getMap().getSize();
            olMap.getView().fit(extent, options);
        }
    }

    getGeometry(params) {
        if (params.geoJson) {
            return this.getGeometryFromGeoJSON(params.geoJson);
        } else if (params.geoJsons) {
            return this.getGeometryFromGeoJSONs(params.geoJsons);
        } else {
            if (params.wkt) {
                return this.getGeometryFromWKT(params.wkt);
            } else {
                console.warn(`params does not contain property 'geoJson', 'geoJsons' or 'wkt'`)
                return null;
            }
        }
    }

    getGeometryFromGeoJSON(geoJson) {
        let format = new GeoJSON();
        return format.readGeometry(geoJson);
    }

    getGeometryFromGeoJSONs(geoJsons) {
        let geomExtent;
        let format = new GeoJSON();
        geoJsons.forEach(item => {
            let geom = format.readGeometry(item);
            if (geomExtent) {
                extentExtend(geomExtent, geom.getExtent());
            } else {
                geomExtent = geom.getExtent();
            }
        });
        return fromExtent(geomExtent);
    }

    getGeometryFromWKT(wkt) {
        let format = new WKT();
        return format.readGeometry(wkt);
    }
}
